import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import { MessageCircle, FileText, Microscope, Activity, Heart, Brain } from 'lucide-react';
import { ChatProvider } from './contexts/ChatContext';
import './App.css';
import ModernChatPage from './components/ModernChatPage';
import DocumentsPage from './components/DocumentsPage';

function Navigation() {
  const location = useLocation();

  return (
    <nav className="medical-gradient shadow-lg animate-fade-in">
      <div className="container mx-auto px-2 sm:px-4 py-2 sm:py-4">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 sm:gap-0">
          <div className="flex items-center space-x-2 sm:space-x-3">
            <div className="bg-white rounded-full p-1 sm:p-2 shadow-md">
              <Microscope className="h-5 w-5 sm:h-6 sm:w-6 text-medical-blue" />
            </div>
            <div>
              <h1 className="text-xl sm:text-2xl font-bold text-white">PaperFlow</h1>
              <p className="text-xs sm:text-sm text-blue-100">Explorez la science avec précision</p>
            </div>
          </div>

          <div className="flex items-center space-x-2 sm:space-x-6">
            <Link
              to="/chat"
              className={`flex items-center space-x-1 sm:space-x-2 px-2 sm:px-4 py-2 rounded-lg transition-all duration-300 text-xs sm:text-sm ${
                location.pathname === '/chat'
                  ? 'bg-white text-medical-blue shadow-md'
                  : 'text-blue-100 hover:bg-white hover:bg-opacity-20'
              }`}
            >
              <MessageCircle className="h-4 w-4 sm:h-5 sm:w-5" />
              <span className="font-medium">Chat</span>
            </Link>
            <Link
              to="/documents"
              className={`flex items-center space-x-1 sm:space-x-2 px-2 sm:px-4 py-2 rounded-lg transition-all duration-300 text-xs sm:text-sm ${
                location.pathname === '/documents'
                  ? 'bg-white text-medical-blue shadow-md'
                  : 'text-blue-100 hover:bg-white hover:bg-opacity-20'
              }`}
            >
              <FileText className="h-4 w-4 sm:h-5 sm:w-5" />
              <span className="font-medium">Documents</span>
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
}

function App() {
  return (
    <Router>
      <ChatProvider>
        <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
          <Navigation />
          <div className="container mx-auto px-2 sm:px-4 py-4 sm:py-8">
            <Routes>
              <Route path="/" element={<ModernChatPage />} />
              <Route path="/chat" element={<ModernChatPage />} />
              <Route path="/documents" element={<DocumentsPage />} />
            </Routes>
          </div>
        </div>
      </ChatProvider>
    </Router>
  );
}

export default App;